// extracted by mini-css-extract-plugin
export default {"Container":"Yps1CHjl","HeaderSubText":"uwN2Rn7i","SubstitutesContainer":"V31xfVGZ","List":"dn02SWD6","Substitutes":"Po64dUjY"};